import { useLocation } from 'react-router';

// ----------------------------------------------------------------------

export default function useUserInvitation() {
  const search = new URLSearchParams(useLocation().search);

  const emailParameter = search.get('email');
  const invitedByMerchantCodeParameter = search.get('invitedByMerchantCode');
  const isUserInvited = !!(emailParameter && invitedByMerchantCodeParameter);

  return {
    isUserInvited,
  };
}
